import { UseQueryResult } from '@tanstack/react-query';
import { mockResponse, useApiQuery } from 'api/use-api-query';
import { AnnotationsApi, AnnotationCategory, ImportersApi, Annotation } from 'oas/internal';

export interface AnnotationLayerResponse {
    id: string;
    activity_id: string;
    annotation_category_id: string;
    name: string;
    start_time_ms: number;
    end_time_ms: number;
    created_at: string;
    modified_at: string;
}

const hardcodedAnnotations: AnnotationLayerResponse[] = [
    {
        id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
        activity_id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
        annotation_category_id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
        name: '20230220DUKELOU_Package_1705953233593',
        start_time_ms: 0,
        end_time_ms: 0,
        created_at: '2023-10-31 23:59:59',
        modified_at: '2023-10-31 23:59:59',
    },
    {
        id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
        activity_id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
        annotation_category_id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
        name: 'string',
        start_time_ms: 0,
        end_time_ms: 0,
        created_at: '2023-10-31 23:59:59',
        modified_at: '2023-10-31 23:59:59',
    },
];

export const useGetAnnotationLayers = (
    ...parameters: Parameters<typeof AnnotationsApi.prototype.getAnnotationsForActivity>
): UseQueryResult<AnnotationLayerResponse[]> => {
    return useApiQuery(['annotation-layers', parameters], () => {
        return mockResponse(hardcodedAnnotations);
    });
};

export const useGetAnnotationCategories = (options = {}): UseQueryResult<AnnotationCategory[]> => {
    return useApiQuery(
        ['annotation', 'categories'],
        (apiConfig, axiosInstance) => new ImportersApi(apiConfig, '', axiosInstance).getAnnotationCategories(),
        options,
        'internal',
    );
};

export const useGetAnnotations = (
    activityId: Parameters<AnnotationsApi['getAnnotationsForActivity']>[0],
    options = {},
): UseQueryResult<Annotation[]> => {
    return useApiQuery(
        ['annotations', activityId],
        (apiConfig, axiosInstance) =>
            new AnnotationsApi(apiConfig, '', axiosInstance).getAnnotationsForActivity(activityId),
        options,
        'internal',
    );
};
